export default {
  OrderManagement: "Review Order",
  Conversation: "Conversation",
  Config: "Config",
  Service: "Service",
  Label: "Label",
  System: "System",
  SystemUsers: "System Users",
  SystemAuth: "System Auth",
  SystemDept: "System Dept",
  SystemRoles: "System Roles",
  SystemOnlineLog: "Online Log",
  Report: "Report",
  PersonalCenter: "Personal Center",
  QuickReply: "Quick Reply",
  statement: "Report Statistics",
};
